<template>
  <div class="toolbar" @click="toggleBreakOutRooms">
    <div 
        class="down-arrow btn-action" 
        :class="[isBreakoutRoomsHidden ? 'outward' : 'inward']"
        >
        <IconBase
            :width="24"
            :height="24"
            :view-box="`0 0 24 24`"
            :fill="'#E7E6FA'"
        >
            <IconAngleDown />
        </IconBase>
    </div>
    <div class="toolbar--title">Rooms</div>
  </div>
</template>

<script>
import IconBase from '../IconBase'
import IconAngleDown from '../icons/IconAngleDown'
import { mapState } from 'vuex'
export default {
    components: {
        IconBase,
        IconAngleDown
    },
    computed: {
        ...mapState({
            isBreakoutRoomsHidden: state => state.rooms.isBreakoutRoomsHidden,
            controls: state => state.user.controls
        })
    },
    methods: {
        toggleBreakOutRooms: function () {
            this.$store.commit('rooms/setBreakoutRoomsHidden');
        }
        
    }

}
</script>

<style scoped>
.toolbar {
    position: fixed;
    display: flex;
    flex-direction: column;
    padding: 15px 0;
    justify-content: space-between;
    align-items: center;
    bottom: 55%;
    width: 40px;
    height: 160px;
    border-radius: 0 8px 8px 0;
    background-color: #1C1C29;
    color: #E7E6FA;
    z-index: 11;
    box-sizing: border-box;
    height: 120px;
    cursor: pointer;
}

@media (max-width: 767px)  {
    .toolbar {
        bottom: auto;
        top: 128px;
    }
}
@media (hover: none)  {
    .toolbar {
        bottom: auto;
        top: 128px;
    }
}

.toolbar .toolbar--title {
    padding-left: 24px;
    transform: rotate(-90deg);
}

.down-arrow.outward{
    transform: rotate(-90deg);  
}

.down-arrow.inward{
    transform: rotate(90deg);  
}

.btn-action:hover {
    background-color: transparent;
}

</style>